<template>
  <div class="contentPadding">
    <iframe
      :src="srcStr"
      style="height:100vh; width:100%; frameborder:0px; border:0px;"
    ></iframe>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "",
  props: {},
  data() {
    return {
      srcStr: "" //iframe引入的地址
    };
  },
  created() {
    this.menulist.forEach(item => {
      if (item.name === "系统管理") {
        item.list.forEach(it => {
          if (it.name === "SQL监控") {
            this.srcStr = it.url;
          }
        });
      }
    });
  },
  computed: {
    ...mapGetters({
      menulist: "menulist"
    })
  },
  watch: {},
  methods: {},
  components: {},
  filters: {}
};
</script>
<style lang="scss" scoped></style>
